<ng-container *ngIf="details?.timeaff||details?.isnotsaved&&!details.isSpOpenDt">
    <div mat-dialog-content>
        <div class="cp5" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxFlex="100" fxLayoutAlign="center center">
                {{ "group_indispnible" | translate }}
            </div>
            <ng-container *ngIf="details.timedelai||details.offretime">
                <div fxFlex="100" fxLayoutAlign="center center">
                    {{ "date_envoi_group" | translate }}
                </div>
                <div fxFlex="100" fxLayoutAlign="center center">

                    {{ details?.data[0]?.spRecvStartDt  }} {{ details?.start|dft}}
                </div>
            </ng-container>
            <ng-container *ngIf="!details.timedelai||details.offretime">
                <div fxFlex="100" fxLayoutAlign="center center">
                    {{ "derniere_delai_group" | translate }}
                </div>

                <div fxFlex="100" fxLayoutAlign="center center">
                    {{ details?.data[0]?.spRecvEndDt  }}{{ details?.end|dft}}
                </div>
            </ng-container>
            <div fxFlex="100" fxLayoutAlign="center center">
                {{ "date_now" | translate }}
            </div>
            <div fxFlex="100" fxLayoutAlign="center center">
                {{ details.datatime | dft }}
            </div>
        </div>
    </div>
</ng-container>